import React , {useContext} from "react";
import app from "./base";
import CallFurioos from "./FurioosController";
import {Component} from "react";
import ReactDOM from 'react-dom';
import AgoraRTC from "agora-rtc-sdk";
import { withRouter, Redirect } from "react-router";
import { AuthContext } from "./Auth.js";
import * as firebase from 'firebase';
import backBanner from "./backBanner.jpg"
import backgroundCentre from "./backgroundCentre.jpg"
import logoParkvillegreens from "./logoParkvillegreens.png"
import personPlaceHolder from './personPlaceHolder.jpg';
import icon_camera from './icon_camera-01.svg'
import loadingGif from './loadingGif.gif';
import App from './App';

const project_code = "parkville_greens_erin_gates";

const PrivateAppointmentCreator = (thisUserEmail, thisUserName) => {

    var userEmail = thisUserEmail;
    var userName = thisUserName;
    var currentHref = window.location.href;

    //all the things we will need from our user

    const SubmitForm = () =>{

        var docAppTime = document.getElementById("meeting-time");
        var docEmail = document.getElementById("emailCreate");
        var docName = document.getElementById("nameCreate");
        var docNumber = document.getElementById("numberCreate");

        var docGuest1 = document.getElementById("guest1");
        var docGuest2 = document.getElementById("guest2");
        var docGuest3 = document.getElementById("guest3");
        var docGuest4 = document.getElementById("guest4");

        var appointmentTime = docAppTime.value;
        var inviteeEmail = docEmail.value;
        var inviteeName = docName.value;
        var inviteePhoneNumber = docNumber.value;

        var guest1Email = docGuest1.value;
        var guest2Email = docGuest2.value;
        var guest3Email = docGuest3.value;
        var guest4Email = docGuest4.value;

        var datetime = new Date(appointmentTime);
        var currentDate = new Date();

        console.log("Appointment time " + datetime.getTime() + " current date " + currentDate.getTime());

        if(CheckIfIsEmail(inviteeEmail) && inviteeName && inviteePhoneNumber && datetime.getTime() > currentDate.getTime()){
            console.log("Inivtee email is an emai, has a name and number");
            setNewAppointment(inviteeEmail,inviteeName,inviteePhoneNumber,datetime.getTime(),guest1Email,guest2Email,guest3Email,guest4Email);
            //this is where we will add things
        }
        else{
            console.log("Missing required form");//need to check whats missing
            if(!inviteeName){
                var nameTitle = document.getElementById("nameTitle");
                nameTitle.className = "RedTitleAboveInput";
            }
            else{
                var nameTitle = document.getElementById("nameTitle");
                nameTitle.className = "GreenTitleAboveInput";
            }

            if(!inviteePhoneNumber){
                var numberTitle = document.getElementById("numberTitle");
                numberTitle.className = "RedTitleAboveInput";
            }
            else{
                var numberTitle = document.getElementById("numberTitle");
                numberTitle.className = "GreenTitleAboveInput";
            }

            if(!CheckIfIsEmail(inviteeEmail)){
                var emailTitle = document.getElementById("emailTitle");
                emailTitle.className = "RedTitleAboveInput";
            }
            else{
                var emailTitle = document.getElementById("emailTitle");
                emailTitle.className = "GreenTitleAboveInput";
            }

            if(datetime.getTime() <= currentDate.getTime()){
                var dateTitle = document.getElementById("dateTitle");
                dateTitle.className = "RedTitleAboveInput";
            }
            else{
                var dateTitle = document.getElementById("dateTitle");
                dateTitle.className = "GreenTitleAboveInput";
            }
        }
        //here we are going to need to add checks if everything is in the correct format
    }

    const BackButton = () =>{
        ReactDOM.unmountComponentAtNode(document.getElementById('rootCam'));
    }
    //All the functions that will put as on clicks to buttons that we will spawn
    const CreatePrivateAppointment = () =>{

        var contentForPage = (
        <>
            <div className="WhiteCoverAdmin">
                <div>
                    <img className="BackBanner" src={backBanner} alt="Banner" />;
                    <img id="parkLogo" className="parkLogo" src={logoParkvillegreens} alt="Logo" />;
                </div>
                
                <div className="BlackFrontOverlayAdmin" id="infoCreationContainer">
                    <h2 className="blackBoxTitle">Appointment Creation</h2>
                    <p className="GreenTitleAboveInput" id="dateTitle">Date</p>
                    <form>
                        <input type="datetime-local" id="meeting-time" name="meeting-time" min="2020-09-15T00:00" max="2021-06-14T00:00"></input>
                    </form>
                    <p className="GreenTitleAboveInput" id="emailTitle">Invitee Email*</p>
                    <input type="email" id="emailCreate" name="email"></input>
                    <p className="GreenTitleAboveInput" id="nameTitle">Invitee Name*</p>
                    <input type="text" id="nameCreate" name="name"></input>
                    <p className="GreenTitleAboveInput" id="numberTitle">Invitee Phone Number*</p>
                    <input type="text" id="numberCreate" name="phoneNumber"></input>
                    <p className="GreenTitleAboveInput">Guest Email</p>
                    <input type="email" id="guest1" name="email"></input>
                    <p className="GreenTitleAboveInput">Guest Email</p>
                    <input type="email" id="guest2" name="email"></input>
                    <p className="GreenTitleAboveInput">Guest Email</p>
                    <input type="email" id="guest3" name="email"></input>
                    <p className="GreenTitleAboveInput">Guest Email</p>
                    <input type="email" id="guest4" name="email"></input>
                    <button className="joinMeetingButton" id="createMeeting" onClick={()=>{SubmitForm();}}>Create Meeting</button>
                    <button className="backMeetingButton" id="backButton" onClick={()=>{BackButton();}}>Back</button>
                </div>
            </div>
        </>
        );

        ReactDOM.render(contentForPage, document.getElementById('rootCam'));
    }

    CreatePrivateAppointment();


    var CheckIfIsEmail = (stringEmail) =>{

        if(stringEmail.includes("@") && stringEmail.includes("."))
        {
            return true;
        }else{
            return false;
        }

    }

    const setNewAppointment = (invitee_email_holder, invitee_full_name_holder, user_phone_number, createTimeMili, guest_1, guest_2, guest_3, guest_4) =>{
        var appointmentPost = app.database().ref('/client_appointments/' + project_code).push();


        var timeMili = createTimeMili;

        var testUserName = thisUserName.replace(/ /g, "_");

        appointmentPost.set({
            appointmentID: appointmentPost.key,
            appointmentName: "Adhoc_Appointment_Made_by_Admin_" + testUserName,
            timeOfAppointment: timeMili,
            assignedTo: "Adhoc",
            started: false
        });

        var userPostRef = app.database().ref('/client_appointments/' + project_code + "/" + appointmentPost.key + "/users").push();
        //this generates push id then we push use set to push user


        userPostRef.set({
            email: invitee_email_holder,
            fullName: invitee_full_name_holder,
            phoneNumber: user_phone_number
        });

        //create link
        //pushID of the appointmengt + "_" + pushID
        var startRef = currentHref.split("p/");
        var urId = userPostRef.key;
        var newRef = startRef[0] + "?linkId=" +appointmentPost.key +"_split_" + urId;

        //invitee_full_name_holder
        //invitee_email_holder
        //user_phone_number



        console.log("WE MADE AN APPOINTMENT");

        //set users email to the appointment list
        var emailPost = app.database().ref('/client_emails/' + project_code).push();

        emailPost.set({
            email:invitee_email_holder,
            appointmentID: appointmentPost.key,
            timeOfAppointment: timeMili
        });

        //do all things above for guests
        if(guest_1 !== "undefined" && guest_1 !==""){
            var guestPostRef1 = app.database().ref('/client_appointments/' + project_code + "/" + appointmentPost.key + "/users").push();

            guestPostRef1.set({
                email: guest_1,
                fullName: "undefined",
                phoneNumber: "undefined"
            });


            setTimeout(() => {
                var emailGuestPost1 = app.database().ref('/client_emails/' + project_code).push();

                emailGuestPost1.set({
                    email:guest_1,
                    appointmentID: appointmentPost.key,
                    timeOfAppointment: timeMili
                });
            },1000);
        }
        if(guest_2 !== "undefined"&& guest_2!==""){
            var guestPostRef2 = app.database().ref('/client_appointments/' + project_code + "/" + appointmentPost.key + "/users").push();
            
            guestPostRef2.set({
                email: guest_2,
                fullName: "undefined",
                phoneNumber: "undefined"
            });

            setTimeout(() => {
                var emailGuestPost2 = app.database().ref('/client_emails/' + project_code).push();

                emailGuestPost2.set({
                    email:guest_2,
                    appointmentID: appointmentPost.key,
                    timeOfAppointment: timeMili
                });
            },1000);
        }
        if(guest_3 !== "undefined" && guest_3!==""){
            var guestPostRef3 = app.database().ref('/client_appointments/' + project_code + "/" + appointmentPost.key + "/users").push();

            guestPostRef3.set({
                email: guest_3,
                fullName: "undefined",
                phoneNumber: "undefined"
            });

            setTimeout(() => {
                var emailGuestPost3 = app.database().ref('/client_emails/' + project_code).push();

                emailGuestPost3.set({
                    email:guest_3,
                    appointmentID: appointmentPost.key,
                    timeOfAppointment: timeMili
                });
            },1000);
        }
        if(guest_4 !== "undefined" && guest_4!==""){
            console.log("send guest")
            var guestPostRef4 = app.database().ref('/client_appointments/' + project_code + "/" + appointmentPost.key + "/users").push();

            guestPostRef4.set({
                email: guest_4,
                fullName: "undefined",
                phoneNumber: "undefined"
            });

            setTimeout(() => {
                var emailGuestPost4 = app.database().ref('/client_emails/' + project_code).push();

                emailGuestPost4.set({
                    email:guest_4,
                    appointmentID: appointmentPost.key,
                    timeOfAppointment: timeMili
                });
            },1000);
        }


        var appointmentID = appointmentPost.key;
        var link = 'https%3A%2F%2Fsales-centre-backend.web.app%2Fsignup%3Flinkid%3D' + appointmentID + '_split_ADMIN';

        var timeAltered = timeMili - 14400000;
        var dateObj = new Date(timeAltered);
        var theDay = dateObj.getDate();
        var theMonth = dateObj.getMonth();
        theMonth = theMonth + 1;
        var theYear = dateObj.getFullYear();
        var appStartTimeDate;


        appStartTimeDate = theYear.toString();
        console.log(" about to get day start");

        if(theMonth < 10){
            appStartTimeDate = appStartTimeDate + "0" + theMonth.toString();
            if(theDay < 10){
                appStartTimeDate = appStartTimeDate + "0" + theDay.toString();
            }
            else{
                appStartTimeDate = appStartTimeDate + theDay.toString();
            }
        }
        else{
            appStartTimeDate = appStartTimeDate + theMonth.toString();
            if(theDay < 10){
                appStartTimeDate = appStartTimeDate + "0" + theDay.toString();
            }
            else{
                appStartTimeDate = appStartTimeDate + theDay.toString();
            }
        }
        
        var hours = dateObj.getUTCHours();
        var minutes = dateObj.getMinutes();
        var appStartTimeHour;
        var appEndTimeHourFloat = hours;
        var appEndTimeString;

        console.log(" about to get day end");
        if(minutes >= 15){
            appEndTimeHourFloat = hours + 1;
            var newMinTime = minutes + 45 - 60;
            
            if(hours < 10){
                console.log("Hours less than 10 start");
                appEndTimeString = "0" + appEndTimeHourFloat.toString();

                if(newMinTime < 10){
                    appEndTimeString = appEndTimeString + "0" + newMinTime.toString() + "00";
                }
                else{
                    appEndTimeString = appEndTimeString + newMinTime.toString() + "00";
                }
                console.log("Hours less than 10 end");
            }
            else{
                console.log("Hours greater than 10 start");
                appEndTimeString = appEndTimeHourFloat.toString();

                if(newMinTime < 10){
                    appEndTimeString = appEndTimeString + "0" + newMinTime.toString() + "00";
                }
                else{
                    appEndTimeString = appEndTimeString + newMinTime.toString() + "00";
                }
                console.log("Hours greater than 10 end");
            }

        }
        else{
            var newMinutes = minutes + 45;
            if(hours < 10){
                appEndTimeString = "0" + hours.toString();
                //var newMinutes = minutes + 45;

                appEndTimeString = appEndTimeString + newMinutes.toString() + "00";
                
            }
            else{
                //var newMinutes = minutes + 45;
                appEndTimeString = hours.toString();

                appEndTimeString = appEndTimeString + newMinutes.toString() + "00";
                
            }
        }
        console.log("time again");
        if(hours < 10){
            appStartTimeHour = "0" + hours.toString();

            if(minutes < 10){
                appStartTimeHour = appStartTimeHour + "0" + minutes.toString() + "00";
            }
            else{
                appStartTimeHour = appStartTimeHour + minutes.toString() + "00";
            }
        }
        else{
            appStartTimeHour = hours.toString();

            if(minutes < 10){
                appStartTimeHour = appStartTimeHour + "0" + minutes.toString() + "00";
            }
            else{
                appStartTimeHour = appStartTimeHour + minutes.toString() + "00";
            }
        }

        var fNameReplace = invitee_full_name_holder.replace(/ /g, "%20");
        var fEmailReplace = invitee_email_holder.replace("@", "%40");
        var fEmailReplace2 = fEmailReplace.replace(".","%2E");
        var phoneReplace = user_phone_number.replace(/-/g, "%2D");
        var additionalDescription = "%20"
        var appointmentName = "Adhoc_Appointment_Made_by_Admin_" + testUserName;
        var str = appointmentName;
        var replacementUnder = str.replace(/_/g, "%20");
        console.log("REPLACED STRING1  " + replacementUnder);
        var callenderLink = "https://www.google.com/calendar/render?action=TEMPLATE&text=" +replacementUnder +"&details=Name%3A%20"+fNameReplace+"%20Email%3A%20"+fEmailReplace2+"%20Phonenumber%3A%20"+phoneReplace+"%20Join%20Meeting%3A%20" +link+"&dates="+ appStartTimeDate +"T" + appStartTimeHour +"%2F"+ appStartTimeDate +"T" + appEndTimeString +"&ctz=America%2FNew_York";
        //var callenderLink = "https://www.google.com/calendar/render?action=TEMPLATE&text=" +replacementUnder +"&details=Join%20Meeting%3A%20" +link+"&dates="+ appStartTimeDate +"T" + appStartTimeHour +"%2F"+ appStartTimeDate +"T" + appEndTimeString +"&ctz=America%2FNew_York";


        FinishedSendingEmailShowConfirmationPopUp(callenderLink);
    }

    const AddToCalender = (googleLink) => {
        window.open(googleLink);
    }

    const FinishedSendingEmailShowConfirmationPopUp = (googleLink) => {

        var contentForCalender = (
            <>
                <div className="WhiteCoverAdmin">
                    <div>
                        <img className="BackBanner" src={backBanner} alt="Banner" />;
                        <img id="parkLogo" className="parkLogo" src={logoParkvillegreens} alt="Logo" />;
                    </div>
                    
                    <div className="BlackFrontOverlayAdmin" id="infoCreationContainer">
                        <h2 className="blackBoxTitle">Appointment Confirmation</h2>
                        <p>Appointment confirmed, client emails will arrive shortly.</p>
                        <button className="joinMeetingButton" id="createMeeting" onClick={()=>{AddToCalender(googleLink); BackButton();}}>Add to Calendar</button>
                    </div>
                </div>
            </>
        );
        ReactDOM.render(contentForCalender, document.getElementById('rootCam'));

    }


}

export default PrivateAppointmentCreator;